import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { updateTripPrices } from "modules/trips/api";
import {
    EuiFieldNumber,
    EuiFlexGroup,
    EuiFlexItem,
    EuiFormRow,
    EuiHorizontalRule,
    EuiTitle,
} from "@elastic/eui";
import SectionsCard from "../shared/tripReconiliation/SectionsCard";

const TripPrice = ({ tripPrices, tripId, setIsPricesChanged, isPricesChanged }) => {
    const [isSaved, setIsSaved] = useState(true);
    const intl = useIntl();
    const [formData, setFormData] = useState({});
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: +value,
        }));
        setIsSaved(false);
    };
    const handleSubmit = () => {
        updateTripPrices(tripId, { trip_price: formData }).then(() => {
            setIsSaved(true);
            setIsPricesChanged(!isPricesChanged);
        });
    };

    return (
        <SectionsCard
            showButton
            title={<FormattedMessage id="trip.reconciliation.tip.price" />}
            onButtonClick={handleSubmit}
            isButtonDisabled={isSaved}
        >
            <EuiFlexGroup
                justifyContent="spaceBetween"
                style={{ position: "relative" }}
                alignItems="baseline"
            >
                <EuiFlexItem grow={1}>
                    <EuiTitle
                        size="xs"
                        style={{ marginBottom: "10px" }}
                    >
                        <h4>
                            <FormattedMessage id="trip.reconciliation.tip.price.client" />
                        </h4>
                    </EuiTitle>
                    <EuiFormRow
                        label={<FormattedMessage id="trip.reconciliation.tip.price.trip" />}
                    >
                        <EuiFieldNumber
                            append={
                                <span style={{ padding: "10px" }}>
                                    <FormattedMessage id="egp" />
                                </span>
                            }
                            value={formData?.trip_price || tripPrices?.tripPrice}
                            onChange={handleChange}
                            min={0}
                            name="trip_price"
                        />
                    </EuiFormRow>
                </EuiFlexItem>

                <EuiHorizontalRule
                    style={{
                        transform: "rotate(90deg)",
                        position: "absolute",
                        top: "265px",
                        right: intl.locale === "ar" ? "24%" : "26%",
                        // right: intl.locale === "ar" ? "210px" : "290px",
                        width: "50%",
                    }}
                    margin="none"
                />
                <EuiFlexItem grow={1}>
                    <EuiFlexGroup
                        direction="column"
                        gutterSize="m"
                    >
                        <EuiTitle
                            size="xs"
                            style={{ marginBottom: "10px" }}
                        >
                            <h4>
                                <FormattedMessage id="trip.reconciliation.tip.price.supply" />
                            </h4>
                        </EuiTitle>
                        <EuiFlexItem>
                            <EuiFormRow
                                label={
                                    <FormattedMessage id="trip.reconciliation.tip.price.supplier" />
                                }
                            >
                                <EuiFieldNumber
                                    append={
                                        <span style={{ padding: "10px" }}>
                                            <FormattedMessage id="egp" />
                                        </span>
                                    }
                                    value={formData?.supplier_wage || tripPrices?.supplierWage}
                                    onChange={handleChange}
                                    min={0}
                                    name="supplier_wage"
                                />
                            </EuiFormRow>
                        </EuiFlexItem>
                        <EuiFlexItem>
                            <EuiFormRow
                                label={
                                    <FormattedMessage id="trip.reconciliation.tip.price.truck" />
                                }
                            >
                                <EuiFieldNumber
                                    append={
                                        <span style={{ padding: "10px" }}>
                                            <FormattedMessage id="egp" />
                                        </span>
                                    }
                                    value={formData?.truck_wage || tripPrices?.truckWage}
                                    onChange={handleChange}
                                    min={0}
                                    name="truck_wage"
                                />
                            </EuiFormRow>
                        </EuiFlexItem>
                        <EuiFlexItem>
                            <EuiFormRow
                                label={
                                    <FormattedMessage id="trip.reconciliation.tip.price.driver" />
                                }
                            >
                                <EuiFieldNumber
                                    append={
                                        <span style={{ padding: "10px" }}>
                                            <FormattedMessage id="egp" />
                                        </span>
                                    }
                                    value={formData?.driver_wage || tripPrices?.driverWage}
                                    onChange={handleChange}
                                    min={0}
                                    name="driver_wage"
                                />
                            </EuiFormRow>
                        </EuiFlexItem>
                    </EuiFlexGroup>
                </EuiFlexItem>
            </EuiFlexGroup>
        </SectionsCard>
    );
};

export default TripPrice;
